var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import WarnList from './WarnList.vue';
import WarnDetail from './WarnDetail.vue';
var TYPETITLE = {
    1: '有效期预警',
    2: '大库存预警',
    3: '滞销预警',
    4: '安全库存预警'
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 1;
        _this.warnVisbile = false;
        _this.warnTitle = '';
        _this.activeName = '0';
        _this.warning_id = '';
        return _this;
    }
    default_1.prototype.tabClick = function (e) {
        if (e.name === '1') {
            this.$refs.WarnDetail.getList();
        }
        else {
            this.warning_id = '';
            this.$refs.WarnDetail.resetAll();
            if (!this.$refs.WarnList.listData.length)
                this.$refs.WarnList.getList();
        }
    };
    default_1.prototype.toDetail = function (warning_id, organ_id, depot_id) {
        this.warning_id = warning_id;
        this.activeName = '1';
        this.$refs.WarnDetail.getList('', warning_id, organ_id, depot_id);
    };
    default_1.prototype.hideWarnModal = function () {
        this.activeName = '0';
        this.warning_id = '';
        this.$refs.WarnList.resetAll();
        this.$refs.WarnDetail.resetAll();
    };
    default_1.prototype.showWarnModal = function (type, activeName, warning_id) {
        var _this = this;
        this.warning_id = warning_id || '';
        this.activeName = activeName || '0';
        this.type = type || 1;
        this.warnTitle = TYPETITLE[this.type];
        this.warnVisbile = true;
        this.$nextTick(function () {
            if (activeName == '1') {
                _this.$refs.WarnDetail.getList('', warning_id);
            }
            else {
                _this.$refs.WarnList.getList();
            }
        });
    };
    __decorate([
        Prop({})
    ], default_1.prototype, "pageAuth", void 0);
    default_1 = __decorate([
        Component({
            components: {
                WarnList: WarnList,
                WarnDetail: WarnDetail,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
